<template>
  <div>
    <div class="music flex-row align-center justify-center">
      <div class="item one"></div>
      <div class="item two"></div>
      <div class="item three"></div>
      <div class="item four"></div>
      <div class="item five"></div>
      <div class="item six"></div>
      <div class="item seven"></div>
      <div class="item four"></div>
      <div class="item five"></div>
      <div class="item three"></div>
      <div class="item two"></div>
      <div class="item five"></div>
      <div class="item six"></div>
      <div class="item seven"></div>
      <div class="item six"></div>
      <div class="item four"></div>
    </div>
  </div>
</template>

<script setup>
import { IonPage } from "@ionic/vue";
import { useListenConfigStore } from "@/hooks/useListenConfigStore";
import { imageConfig } from "@/views/listening/components/ThemeTag/imageConfig";

const listenStore = useListenConfigStore();
import { computed } from "vue";
const imageMap = computed(() => imageConfig[theme.value]);

const theme = computed(() => listenStore.theme);
</script>

<style scoped lang="less">
@import "ThemeTag/listenTheme";
.music {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.item {
  width: 0.18rem;
  border-radius: 9px;
  background-color: var(--sound-wave-bg);
}

.music .one {
  height: 0.5rem;
  animation: radius-animation 0.3s ease
}
.music .two {
  height: 0.75rem;
  animation: radius-animation 0.6s ease;
}
.music .three {
  height: 1rem;
  animation: radius-animation 0.57s ease;
}
.music .four {
  height: 1.4rem;
  animation: radius-animation 0.52s ease;
}
.music .five {
  height: 1rem;
  animation: radius-animation 0.4s ease;
}
.music .six {
  height: 1.1rem;
  animation: radius-animation 0.3s ease;
}
.music .seven {
  height: 0.65rem;
  animation: radius-animation 0.7s ease;
}

.music .item {
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
  animation-direction: alternate;
  -webkit-animation-direction: alternate;
}

@keyframes radius-animation {
  100% {
    height: 0.4rem;
    border-radius: 50%;
    filter: contrast(2);
    //background-color: rgba(16, 194, 139, 0.70);
  }
}
</style>
